import {ApiClient} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";

export const useProgramEpisodeKey = (
    id: number,
    slugProgram: string,

    ) => ({
    queryKey: ["useProgramEpisodeKey", slugProgram, id],
    queryFn: useFetcher(() => new ApiClient().getApiPodcastEpisode({
        programSlug: slugProgram,
        id: id
    },{
        credentials: "include",
        signal: Aborted().signal
    }))
})